export default __webpack_public_path__ + "static/media/portfolio.a606b99b.png";